import styled from '@emotion/styled';
import { theme } from '../../styles';

export const ContactContainer = styled.div`
  
`;

export const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  margin: 40px auto 0;
  overflow: visible;
  position: relative;

  @media (min-width: ${theme.breakpoints.md}) {
    margin: 0px auto 50px;
    padding: 0 15px;
  }

  .BigCircle {
    width: 100%;
  }

  label {
    margin-top: -35px;
    font-family: ${theme.fontFamily.secondary};
    text-transform: uppercase;
    font-size: ${theme.fonts.xl_small};
    font-weight: 600;
    color: black;

    @media (min-width: ${theme.breakpoints.md}) {
      margin-top: -35px;
    }
  }

  .MuiFormControl-root {
    margin-bottom: 25px;
  }

  .MuiInputBase-root {
    background-color: white;
  }

  .MuiInputBase-input {
    font-weight: 500;
    font-size: ${theme.fonts.m};
  }

  .MuiOutlinedInput-root {
    border-radius: 0;

    .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.colors.primaryred};
      border-width: 2px;
      transition: border-color 300ms linear;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: black;
    }
  }

  .MuiButtonBase-root {
    box-shadow: none;
    border-radius: 0;
    font-family: ${theme.fontFamily.secondary};
    text-transform: uppercase;
    font-size: ${theme.fonts.md};
    font-weight: 600;
    background: black;
    border: 2px solid black;
    

    &:hover {
      box-shadow: none;
      border: 2px solid black;
      background: white;
      color: black;
    }
  }
`;
